module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/icon-step-1@2x_979cf7688e657526a0b70c47382be40d.png";